import Request from './BusinessTripRequest'
import BusinessTripRequestEmployee from './BusinessTripRequestEmployee'
import BusinessTripRequestExpense from './BusinessTripRequestExpense'

const BusinessTripRequest = {
  namespaced: true,
  modules: {
    Request,
    Employees: BusinessTripRequestEmployee,
    Expenses: BusinessTripRequestExpense
  },
  actions: {
    reset: (context, payload) => {
      context.dispatch('Request/reset', payload)
      context.dispatch('Employees/reset', payload)
      context.dispatch('Expenses/reset', payload)
    }
  }
}

export default BusinessTripRequest



// WEBPACK FOOTER //
// ./src/store/business-trip-request/index.js